import React, { useContext } from 'react';
import { StyleSheet } from 'react-native';
import { QuickFiltersContext } from './QuickFiltersProvider';
import WidgetContainer from 'src/screens/Home/Widgets/WidgetContainer';
import { DNABox, DNAButton, util } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  quickFiltersContainer: {
    flexWrap: 'wrap',
    width: '100%',
  },
  selectedButton: {
    backgroundColor: colors['color-brand1-10'],
  },
  buttonMargin: {
    marginVertical: 4,
  },
});

const QuickFiltersHomeUI2 : React.FC = () => {
  const { quickFilters, selectedPath, handleToggleFilter } = useContext(QuickFiltersContext);

  return (
    <WidgetContainer title="Quick Filters">
      <DNABox fill>
        <DNABox alignY="center" spacing="sm" wrap="start" style={styles.quickFiltersContainer}>
          {quickFilters.map((filter, index) => {
            const isSelected = selectedPath === index;
            return (
              <DNAButton
                key={`${filter.id}-${index}`}
                testID="quickfilter-path"
                appearance="outline"
                status={isSelected ? 'secondary' : 'tertiary'}
                onPress={() => handleToggleFilter(filter.id, isSelected, index)}
                style={util.mergeStyles(
                  undefined,
                  styles.buttonMargin,
                  [styles.selectedButton, isSelected],
                )}
              >
                {filter.label}
              </DNAButton>
            )
          })}
        </DNABox>
      </DNABox>
    </WidgetContainer>
  )
}

export default QuickFiltersHomeUI2;
